import { createTheme } from '@mui/material/styles';

/**
 * MUI theme mirroring the design tokens used throughout the app
 * (see src/styles/global.css for the raw CSS custom properties these
 * are derived from). Keeping both in sync means MUI primitives like
 * <Switch>, <Select>, <Fab> automatically match the bespoke
 * calendar / wheel-picker / bottom-sheet UI built with plain CSS.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: '#3F6659',
      light: '#C3EEDC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FF8A65',
      light: '#FFDBCB',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFBF5',
      paper: '#F4EFE5',
    },
    text: {
      primary: '#1C1C18',
      secondary: '#4B4B42',
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: "'Noto Sans JP', 'Zen Maru Gothic', sans-serif",
    button: {
      fontFamily: "'Zen Maru Gothic', 'Noto Sans JP', sans-serif",
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999 },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: { borderRadius: 24 },
      },
    },
  },
});

export default theme;
